import { render, staticRenderFns } from "./DrawerInstanceSection.vue?vue&type=template&id=3bb9317c&"
import script from "./DrawerInstanceSection.vue?vue&type=script&lang=js&"
export * from "./DrawerInstanceSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports